let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6nr9L"), load("7ofLD"), load("1a9Rr")]).then(() => parcelRequire('7fnEu'));